import { BlobProvider } from "@react-pdf/renderer";
import { useState } from "react";
import { JobBoardPdfDocument } from "./JobBoardPdfDocument";
import API from "services/axios";
import authHeader from "services/auth-header";

function JobBoardPdf({
  filterBy,
  API_CALL,
  filterText,
  selectedLocation,
  dateFrom,
  dateTo,
  sortBy,
  sortDir,
}) {
  const [fullData, setFullData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAll = async () => {
    if (!API_CALL) {
      setError("No API endpoint provided");
      return;
    }

    if (fullData) return; // already fetched

    try {
      setLoading(true);
      setError(null);

      const searchQuery = filterText?.trim();
      const { data } = await API.post(
        `${API_CALL}?page=1&limit=10000`,
        {
          query: searchQuery || undefined,
          productTypeId: filterBy?.productTypeId || undefined,
          locationId: selectedLocation || undefined,
          getQty: true,
          // Same filters the card is showing. Without these, exporting a
          // card filtered to This Week hands back the entire board.
          dateFrom: dateFrom || undefined,
          dateTo: dateTo || undefined,
          sortBy: sortBy || undefined,
          sortDir: sortBy ? sortDir : undefined,
        },
        { headers: authHeader() },
      );

      if (data?.success) {
        setFullData(data.data || []);
      } else if (data?.type === "success") {
        setFullData(data.result || []);
      } else if (data?.type === "error") {
        setError(data.message || "Failed to fetch data");
      } else {
        setFullData([]);
      }
    } catch (err) {
      setError(err.message || "Unexpected error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {!fullData ? (
        <button
          onClick={fetchAll}
          disabled={loading}
          className="text-decoration-none text-white btn btn-success me-1 btn-sm ms-1"
        >
          <i className="mdi mdi-download"></i>
          {loading ? " Preparing..." : " Download Report"}
        </button>
      ) : (
        <BlobProvider
          document={
            <JobBoardPdfDocument filterBy={filterBy} workOrderList={fullData} />
          }
        >
          {({ url, blob }) => {
            const isDisabled = !blob;
            return (
              <>
                <a
                  href={isDisabled ? "#" : url}
                  download={`Job-Board-Report-${new Date().toISOString().slice(0, 10)}.pdf`}
                  className="text-decoration-none text-white btn btn-success me-1 btn-sm ms-1"
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-download"></i>Download Report
                </a>
                <a
                  href={isDisabled ? "#" : url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-white btn btn-primary me-1 btn-sm ms-1"
                  onClick={(e) => {
                    if (isDisabled) e.preventDefault();
                  }}
                >
                  <i className="mdi mdi-eye"></i>View Report
                  {!url && (
                    <div
                      className="spinner-border spinner-border-sm text-white ms-2 mb-1"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </a>
              </>
            );
          }}
        </BlobProvider>
      )}

      {error && <div className="text-danger small mt-1">{error}</div>}
    </>
  );
}

export default JobBoardPdf;
